import React, { useCallback, useEffect, useRef, useState } from 'react';
import { format } from 'date-fns';
import Paginator from '../paginator';
import { useSelector } from 'react-redux';
import CreateSolpDialog from './creaSolp';
import AproSolp from './aproSolp';
import { apiurl } from '../../utils/constants';
import ModUserDialog from '../cc/editCC';
import { fCurr } from '../../utils/functions';
import ReloadButton from '../../utils/reload';

function ListSolp({ onMenuItemClick, filtr }) {

	const { iden: user, mail } = useSelector((state) => state.user);

	const [paginatedSolp, setPaginatedSolp] = useState([]);
	const [cc, setCC] = useState([]);
	const [autorized, setAutorized] = useState([]);

	const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
	const [approvalRequest, setApprovalRequest] = useState(null);
	const [approvingRequestId, setApprovingRequestId] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	//Atajos
	const [filtDraf, setFiltDraf] = useState(false);
	const [filtMySolp, setFiltMySolp] = useState(false);
	const [filtMySolpPend, setFiltMySolpPend] = useState(false);
	const [filtReqMyAppr, setFiltReqMyAppr] = useState(false);
	const [filtMyAppr, setFiltMyAppr] = useState(false);

	//Filtros
	const [filtCode, setFiltCode] = useState('');
	const [filtCodeAF, setFiltCodeAF] = useState('');
	const [filtCC, setFiltCC] = useState('');
	const filtCCMatch = cc.find(c => c.name === filtCC || String(c.code) === filtCC);
	const [filtStat, setFiltStat] = useState(false);
	const [filtRequ, setFiltRequ] = useState({ iden_user: null, name_user: '' });
	const [filtRequDateStart, setFiltRequDateStart] = useState(false);
	const [filtRequDateEnd, setFiltRequDateEnd] = useState(false);
	const [filtAppr, setFiltAppr] = useState(false);
	const [filtApprDateStart, setFiltApprDateStart] = useState(false);
	const [filtApprDateEnd, setFiltApprDateEnd] = useState(false);
	const [filtUrge, setFiltUrge] = useState(false);

	const [listUserDialog, setListUserDialog] = useState(false);
	const [listUserDialog2, setListUser2Dialog] = useState(false);

	const [totalFiltered, setTotalFiltered] = useState(0);
	const [filtersReady, setFiltersReady] = useState(false);
	const previousFilters = useRef(null);
	const currentUrl = window.location.href;

	const handleApproveClick = (event, solped) => {
		event.preventDefault();
		event.stopPropagation();

		setApprovingRequestId(solped.iden);
		setApprovalRequest({
			iden: solped.iden,
			items: solped.details ?? [],
		});
	};


	const loadSolped = useCallback(async (pageToLoad = currentPage, signal) => {
		try {
			const response = await fetch(apiurl + 'requests/list', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				signal,
				body: JSON.stringify({
					user: mail,
					page: pageToLoad,
					pageSize: itemsPerPage,
					shortcuts: {
						drafts: filtDraf,
						myRequests: filtMySolp,
						myPendingRequests: filtMySolpPend,
						requiresMyApproval: filtReqMyAppr,
						approvedByMe: filtMyAppr,
					},
					filters: {
						code: filtCode,
						fixedAsset: filtCodeAF,
						costCenter: filtCCMatch ? String(filtCCMatch.code) : filtCC,
						status: filtStat || '',
						requesterId: filtRequ?.iden_user ?? null,
						requestedStart: filtRequDateStart || null,
						requestedEnd: filtRequDateEnd || null,
						approverId: filtAppr?.iden_user ?? null,
						approvedStart: filtApprDateStart || null,
						approvedEnd: filtApprDateEnd || null,
						urgent: filtUrge,
					},
				}),
			});

			if (!response.ok) throw new Error('Error al obtener las solicitudes');
			const data = await response.json();
			const rows = (data.rows ?? []).map(row => ({
				...row,
				details: typeof row.details === 'string' ? JSON.parse(row.details) : (row.details ?? []),
				ordes: typeof row.ordes === 'string' ? JSON.parse(row.ordes) : (row.ordes ?? []),
			}));

			setPaginatedSolp(rows);
			setTotalFiltered(Number(data.total) || 0);
			return { rows, total: Number(data.total) || 0 };
		} catch (error) {
			if (error.name !== 'AbortError') console.log('Error en loadSolped ', error);
			return null;
		}
	}, [currentPage, mail, filtDraf, filtMySolp, filtMySolpPend, filtReqMyAppr, filtMyAppr, filtCode, filtCodeAF, filtCC, filtCCMatch,
		filtStat, filtRequ, filtRequDateStart, filtRequDateEnd, filtAppr, filtApprDateStart, filtApprDateEnd, filtUrge]);
	const loadListCC = async () => {

		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					query: `SELECT code, name,
								EXISTS(SELECT 1 FROM req__assi assi
									LEFT JOIN sys__link link ON assi.posi = link.posi
									WHERE req__cent.code = assi.cent AND link.user = ${user}) valid
							FROM req__cent;` }),
				credentials: 'include'
			});

			if (response.ok) {
				const data = await response.json();

				// Almacena todos los CC del sistema con code y name en setCC
				const formattedData = data.map(item => ({ code: item.code, name: item.name }));
				setCC(formattedData);

				// Almacena solo los CC a los que el usuario tiene acceso
				const authorizedCodes = data.filter(item => item.valid === 1).map(item => item.code);
				setAutorized(authorizedCodes);

			} else {
				console.error('Error al obtener los CC');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}

	}

	useEffect(() => {
		loadListCC();

		if (typeof filtr === 'string') {
			if (filtr === 'draf') setFiltDraf(true);
			if (filtr === 'publ') setFiltMySolpPend(true);
			if (filtr === 'appr') setFiltReqMyAppr(true);
		} else if (typeof filtr === 'object' && filtr !== null) {
			if (filtr.filtDraf) setFiltDraf(filtr.filtDraf);
			if (filtr.filtMySolp) setFiltMySolp(filtr.filtMySolp);
			if (filtr.filtMySolpPend) setFiltMySolpPend(filtr.filtMySolpPend);
			if (filtr.filtReqMyAppr) setFiltReqMyAppr(filtr.filtReqMyAppr);
			if (filtr.filtMyAppr) setFiltMyAppr(filtr.filtMyAppr);
			if (filtr.filtCode) setFiltCode(filtr.filtCode);
			if (filtr.filtCodeAF) setFiltCodeAF(filtr.filtCodeAF);
			if (filtr.filtCC) setFiltCC(filtr.filtCC);
			if (filtr.filtStat) setFiltStat(filtr.filtStat);
			if (filtr.filtUrge) setFiltUrge(filtr.filtUrge);
			if (filtr.filtRequ) setFiltRequ(filtr.filtRequ);
			if (filtr.filtAppr) setFiltAppr(filtr.filtAppr);
			if (filtr.filtRequDateStart) setFiltRequDateStart(filtr.filtRequDateStart);
			if (filtr.filtRequDateEnd) setFiltRequDateEnd(filtr.filtRequDateEnd);
			if (filtr.filtApprDateStart) setFiltApprDateStart(filtr.filtApprDateStart);
			if (filtr.filtApprDateEnd) setFiltApprDateEnd(filtr.filtApprDateEnd);
			if (filtr.currentPage) setCurrentPage(filtr.currentPage);
		}

		setFiltersReady(true);
		// eslint-disable-next-line
	}, []);

	const filterSignature = JSON.stringify({
		filtDraf, filtMySolp, filtMySolpPend, filtReqMyAppr, filtMyAppr,
		filtCode, filtCodeAF, filtCC, filtStat, filtRequ,
		filtRequDateStart, filtRequDateEnd, filtAppr,
		filtApprDateStart, filtApprDateEnd, filtUrge,
	});

	useEffect(() => {
		if (!filtersReady) return;

		if (previousFilters.current === null) {
			previousFilters.current = filterSignature;
		} else if (previousFilters.current !== filterSignature) {
			previousFilters.current = filterSignature;
			if (currentPage !== 1) {
				setCurrentPage(1);
				return;
			}
		}

		const controller = new AbortController();
		const timer = setTimeout(() => loadSolped(currentPage, controller.signal), 250);

		return () => {
			clearTimeout(timer);
			controller.abort();
		};
	}, [currentPage, filterSignature, filtersReady, loadSolped]);

	const handleApprovalRefresh = async () => {
		const result = await loadSolped(currentPage);
		setApprovingRequestId(null);
		if (result?.rows.length === 0 && currentPage > 1) setCurrentPage(currentPage - 1);
	};


	return (<>
		<form>
			<style jsx="true" > {`.itemTable .ellipsis{ max-width: 500px; }`} </style>
			<main>
				<h1 data-icon='' > Solicitudes de pedido </h1>
				<nav>
					{
						paginatedSolp.map(solped => (
							<article key={solped.iden}
								onClick={() => onMenuItemClick('listSolpDeta', solped.iden, null,
									{
											currentPage, filtDraf, filtMySolp, filtMySolpPend, filtReqMyAppr, filtMyAppr,
										filtCode, filtCC, filtStat, filtUrge, filtRequ, filtAppr,
										filtRequDateStart, filtRequDateEnd, filtApprDateStart, filtApprDateEnd, filtCodeAF
									})}  >
								<div className={solped.urge ? 'yel' : ''}>
									<h2>
										<div>{solped.req_name ? solped.req_name : (solped.rejected ? (<><orm-icon className="red" ></orm-icon>{` Rechazado`}</>) : 'Borrador')}</div>
										<div>{solped.cc_name}</div>
										<div>{solped.requested ? format(new Date(solped.requested), 'dd/MM/yyyy') : '--/--/----'}</div>
									</h2>
								</div>
								<table className='requestTable'>
									<tbody>
										<tr>
											<th className={solped.docu ? '' : 'disabled'}> {solped.docu ?? solped.iden} </th>
											<td className={solped.stat === 'Recibido' ? 'done' : ''} >
												<table className='itemTable' >
													<tbody>
														{
															solped.details.map((detail, index) => (
																<tr key={index} >
																	<td>{detail.item_code}</td>
																	<td className='ellipsis' > {detail.item_name} {/[a-zA-Z]/.test(detail.item_code) && detail.text && `: ${detail.text}`}</td>
																	<td>
																		{solped.entry ? detail.pend + '/' : ''}
																		{detail.amou}
																	</td>
																</tr>))
														}
													</tbody>
												</table>
											</td>
											<th> {fCurr(solped.totalValue)} CLP </th>
											<td className={`state ${solped.stat === 'Cerrado' ? 'gra' : (solped.stat === 'Recibido' ? 'blu' : (solped.stat === 'Comprado' ? 'gre' : (solped.stat === 'Comprando' ? 'yel' : (solped.stat === 'Aprobado' ? 'ora' : (solped.stat === 'Borrador' ? '' : (solped.stat === 'Entregado' ? 'pur' : 'red'))))))}`}>
												<mark>{solped.stat}</mark>
												<time> {
													format(new Date(solped.clos ? solped.clos : solped.approved ? solped.approved : solped.requested ? solped.requested : solped.rejected ? solped.rejected : solped.submitted), 'dd/MM/yyyy')
												}</time>
												<orm-step style={{ marginBottom: '5px' }}> </orm-step>
												<div className='scroll'>
													{
														solped.ordes.map((orde, index) => (
															orde.docu ? <div key={index} >
																<figure className={orde.stat === 'O' ? "red" : "gre"} ></figure> OC {orde.docu}
															</div> : ''
														))
													}
												</div>
												{solped.stat === 'Solicitado' && solped.canApprove === 1 && (
													<input
														type="button"
														value="Aprobar"
														style={{ width: '100%' }}
														disabled={approvingRequestId === solped.iden}
														onClick={(event) => handleApproveClick(event, solped)}
													/>
												)}
											</td>
										</tr>
									</tbody>
								</table>
							</article>

						))
					}
				</nav>
				<nav>
					<article><Paginator totalItems={totalFiltered} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={setCurrentPage} /> </article>
				</nav>
			</main>
			<aside>
				{
					autorized.length > 0 && (
						<article>
							<h2>Acciones </h2>
							<fieldset>
								<ReloadButton onReload={loadSolped} />
								<input type="button" value="Crear solicitud de pedido" onClick={() => setIsCreateDialogOpen(true)} />
								<input type="button" value="Ver estadísticas" onClick={() => onMenuItemClick('listStat')} />
							</fieldset>
						</article>
					)
				}
				<article>
					<h2>Atajos</h2>
					<fieldset>
						<a href={currentUrl} className={filtDraf ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltDraf(!filtDraf); }}> Mis borradores </a>
						<a href={currentUrl} className={filtMySolp ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltMySolp(!filtMySolp); }}> Mis solicitudes </a>
						<a href={currentUrl} className={filtMySolpPend ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltMySolpPend(!filtMySolpPend); }}> Mis solicitudes pendientes</a>
						<a href={currentUrl} className={filtReqMyAppr ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltReqMyAppr(!filtReqMyAppr); }}> Requieren mi aprobación </a>
						<a href={currentUrl} className={filtMyAppr ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltMyAppr(!filtMyAppr); }}> Aprobadas por mí </a>
					</fieldset>
				</article>
				<article>
					<h2>Filtros </h2>
					<fieldset>
						<legend>Información </legend>
						<input type="search" placeholder="Código" value={filtCode} onChange={e => { setFiltCode(e.target.value); }} />
						<input type="search" placeholder="Activo Fijo" value={filtCodeAF} onChange={e => { setFiltCodeAF(e.target.value); }} />
						<input type="search" placeholder="Centro de costos" list="cent" value={filtCC} onChange={e => setFiltCC(e.target.value)} />
						<datalist id="cent"> {cc
							.slice()
							.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
							.map((c) => (
								<option key={c.code} value={c.code}>{c.name}</option>
							))} </datalist>
						<select value={filtStat} onChange={e => { setFiltStat(e.target.value); }}>
							<option value=''> Estado </option>
							<option value='Borrador'> Borrador </option>
							<option value='Solicitado'> Solicitado </option>
							<option value='Aprobado'> Aprobado </option>
							<option value='Comprando'> Comprando </option>
							<option value='Comprado'> Comprado </option>
							<option value='Recibido'> Recibido </option>
							<option value='Entregado'> Entregado </option>
							<option value='Cerrado'> Cerrado </option>
						</select>
						<input id="urgency" type="checkbox" checked={filtUrge} onChange={e => { setFiltUrge(!filtUrge); }} />
						<label htmlFor="urgency"> Solo urgencias</label>
					</fieldset>

					<fieldset>
						<legend>Solicitud</legend>
						<input type="text" placeholder="Solicitante" value={filtRequ.name_user} className="picker user clear" onClick={() => { setListUserDialog(true); }} readOnly />
						<orm-icon className="red" onClick={() => { setFiltRequ({ iden_user: null, name_user: '' }); }}></orm-icon>
						<input type="date" value={filtRequDateStart} onChange={(e) => { setFiltRequDateStart(e.target.value); }} />
						<input type="date" value={filtRequDateEnd} onChange={(e) => { setFiltRequDateEnd(e.target.value); }} />
					</fieldset>

					<fieldset>
						<legend>Aprobación</legend>
						<input type="text" placeholder="Aprobador" value={filtAppr.name_user} className="picker user clear" onClick={() => { setListUser2Dialog(true); }} readOnly />
						<orm-icon className="red" onClick={() => { setFiltAppr({ iden_user: null, name_user: '' }); }}></orm-icon>
						<input type="date" value={filtApprDateStart} onChange={(e) => { setFiltApprDateStart(e.target.value); }} />
						<input type="date" value={filtApprDateEnd} onChange={(e) => { setFiltApprDateEnd(e.target.value); }} />
					</fieldset>

				</article>
			</aside>
		</form>
		{isCreateDialogOpen && <CreateSolpDialog onMenuItemClick={onMenuItemClick} onUpdateSolpList={loadSolped} listAutorized={autorized} onClose={() => setIsCreateDialogOpen(false)} />}
		{approvalRequest && <AproSolp
			solp={approvalRequest.iden}
			items={approvalRequest.items}
			onClose={(approved) => {
				setApprovalRequest(null);
				if (!approved) setApprovingRequestId(null);
			}}
			onRefresh={handleApprovalRefresh}
		/>}
		{listUserDialog && <ModUserDialog onUpdateCCList={null} onEditCC={null} onClose={() => setListUserDialog(false)} onListUser={null} onSetListUser={null} onSetOneUser={setFiltRequ} />}
		{listUserDialog2 && <ModUserDialog onUpdateCCList={null} onEditCC={null} onClose={() => setListUser2Dialog(false)} onListUser={null} onSetListUser={null} onSetOneUser={setFiltAppr} />}

	</>);
}


export default ListSolp;
